$(document).ready(function(){
	
    $('#scrollbar1').tinyscrollbar();
    $('#scrollbar3').tinyscrollbar();
    $('#scrollbar7').tinyscrollbar();
    $('#scrollbar8').tinyscrollbar();

    
    $(".product-feature-photo").colorbox();
    $(".product-photo").colorbox({rel:'group1'});
    
    $(".guitargallery").colorbox({rel:'group2'});
        $(".guitargallery1").colorbox({rel:'group3'});
    
    
    $('#guitar .image a').click(function() {
        jQuery('#guitar .image a').removeClass('active').addClass('link');
        jQuery(this).removeClass('link').addClass('active');
    });
    
    $("#details-links a").click(function() {
            var $producttab = jQuery(this).attr('id');
            $('#details-links a').removeClass('active').addClass('link');
            $(this).removeClass('link').addClass('active');
            $("#product-details .details-description").removeClass('active');
            $("#product-details #product-"  + $producttab).addClass('active');
            return false;
    });
    
    $(".nav-tabs li a").click(function() {
            var $tab = jQuery(this).attr('id');
            $('.nav-tabs li a').removeClass('active').addClass('link');
            $(this).removeClass('link').addClass('active');
            $(".content .contentblock").removeClass('active');
            $(".content ."  + $tab).addClass('active');
            $(".content .specs .spec").removeClass('active');
            $(".content .specs .intro").addClass('active');
            $('#guitar .image a').removeClass('active').addClass('link');
            var dScrollbar = $('#scrollbar8');
            dScrollbar.tinyscrollbar();
            dScrollbar.tinyscrollbar_update();
            return false;
    });
    
    $("#guitar .image a").click(function() {
            var $spec = jQuery(this).attr('id');
            $('.nav-tabs li a').removeClass('active').addClass('link');
            $('.nav-tabs li a#specs').removeClass('link').addClass('active');
            $('#guitar .image a').removeClass('active').addClass('link');
            $(this).removeClass('link').addClass('active');
            $(".content .contentblock").removeClass('active');
            $(".content .specs").addClass('active');
            $(".content .specs .spec").removeClass('active');
            $(".content .specs ."  + $spec).addClass('active');
            var oScrollbar = $('#scrollbar7');
            oScrollbar.tinyscrollbar();
            oScrollbar.tinyscrollbar_update();
            return false;
    });
    

});



